export default function (instance) {
  return {
    submitOrder (bundles, paymentMethodCode, trackCookie, cancelPaymentUrl) {
      return instance
        .post('/api/orders', {
          bundles,
          paymentMethodCode,
          trackCookie,
          cancelPaymentUrl
        })
        .then(response => response.data)
    }
  }
}
